import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavigationService } from '../../../commons/services/navigation.service';
import { TvLoginStore } from './app.store';

export const selectPortalGuard: CanActivateFn = () => {
  const tvLoginStore = inject(TvLoginStore);
  const navigationService = inject(NavigationService);

  if (tvLoginStore.portals().length > 0) {
    return true;
  }

  return navigationService.goToLogin();
};
